import React from 'react';
import { Link } from 'gatsby';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faCog,
  faFolder,
  faChartLine,
  faTasks,
  faUser,
  faQuestionCircle,
  faCube
} from '@fortawesome/free-solid-svg-icons'

import './Sidebar.scss';

import logo from '../../../assets/tu_logo.png'; // Tell Webpack this JS file uses this image



const categories_account = [
	{
		id: 'Dashboard',
		children: [
			{ id: 'Home', icon: <FontAwesomeIcon icon={faHome} />, page: '/' },
			{ id: 'Assets', icon: <FontAwesomeIcon icon={faFolder} />, page: '/upload' },
			{ id: 'Campaign Support', icon: <FontAwesomeIcon icon={faQuestionCircle} />, page: '/support' },
			{ id: 'Live Campaigns', icon: <FontAwesomeIcon icon={faCube} />, page: '/campaigns' },
		],
	},
	{
		id: 'Account',
		children: [
			{ id: 'Setup', icon: <FontAwesomeIcon icon={faTasks} />, page: '/checklist' },
			{ id: 'Settings', icon: <FontAwesomeIcon icon={faCog} />, page: '/account' },
			{ id: 'Accounts', icon: <FontAwesomeIcon icon={faUser} />, page: '/linkaccounts' },
			{ id: 'Performance', icon: <FontAwesomeIcon icon={faChartLine} />, page: '/home' },
			// { id: 'Contact', icon: <FontAwesomeIcon icon={faQuestionCircle} />, page: '/contact' },
			{ id: 'Plan', icon: <FontAwesomeIcon icon={faQuestionCircle} />, page: '/plan' },
		],
	},
]


const categories = [
	{
		id: 'Account',
		children: [
			{ id: 'My Accounts', icon: <FontAwesomeIcon icon={faTasks} />, page: '/checklist' },
			{ id: 'Settings', icon: <FontAwesomeIcon icon={faCog} />, page: '/account' },
		],
	},
]

const Sidebar = () => {

	const account = true, accountActive = true;
	let nav;

	// If They are associated with an account SHOW account nav
	(account && accountActive ? nav = categories_account : nav = categories);

  return (
    <div className="SideBar">
      <div className="SideBar__logo">
        <Link to={"/"}>
          <img 
              className="SideBar__logo__image"
              src={logo}
          />
          </Link>
      </div>
      <div className="SideBar__main">
      	{nav.map(({ id, children }) => (
			<React.Fragment key={id}>
				<div className="categoryHeader">
					<div
						className=" ListItemTextcategoryHeaderPrimary"
					>
						<h3>{id}</h3>
					</div>
				</div>
				{children.map(({ id: childId, icon, page = null }) => {
					return page ? (
						<Link
							key={childId}
							style={{ textDecoration: 'none', color: 'inherit' }}
							to={`/${page}`}
						>
							<div className="ListItem"
							>
								<div className="ListItemIcon">
				{icon}
			</div>
								<div className="ListItemText"
								>
									{childId}
								</div>
							</div>
						</Link>
					) : (
						<div />
					)
				})}
				<div className="divider"></div>
			</React.Fragment>
		))}
      </div>
    </div>
  );
};

export default Sidebar;